import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-modal', 'accept', 'Yes');
Labels.set('ui-modal', 'decline', 'No');
Labels.set('ui-modal', 'dismiss', 'OK');
Labels.set('ui-modal', 'close', 'Close');
Labels.set('ui-modal', 'back', 'Back');
Labels.set('ui-modal', 'opened', 'Pop-up window is opened');
